module.exports = __webpack_public_path__ + "img/yangliCkxl.79b7d5c8.png";